import { gql } from '@apollo/client'

import { STORE_FRAGMENT } from '../fragments'

export const DELETE_STORE = gql`
  mutation DeleteStore($id: ID!) {
    deleteStore(data: { id: $id }) {
      ...Store
    }
  }
  ${STORE_FRAGMENT}
`
